import { NgModule } from "@angular/core";
import { MenuModule } from "../menu/menu.module";
import { SharedImportsModule } from "../shared/shared-imports.module";
import { MatPaginatorModule } from '@angular/material/paginator';
import { TableControlsComponent } from "../shared/table-controls/table-controls.component";
import { CommonModule } from '@angular/common';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { ERTEmergencyResponseComponent } from "./ert-emergency-response.component";
import { SharedModule } from "../shared.module";
import { ErtEmergencyResponseViewComponent } from './ert-emergency-response-view/ert-emergency-response-view.component';
import { ErtEmergencyResponseAddmrsCreateComponent } from './ert-emergency-response-addmrs/ert-emergency-response-addmrs-create/ert-emergency-response-addmrs-create.component';
import { ErtEmergencyResponseAddmrsAdditionalInfoComponent } from './ert-emergency-response-addmrs/ert-emergency-response-addmrs-additional-info/ert-emergency-response-addmrs-additional-info.component';
import { ErtEmergencyResponseAddmrsPatientVitalsComponent } from './ert-emergency-response-addmrs/ert-emergency-response-addmrs-patient-vitals/ert-emergency-response-addmrs-patient-vitals.component';
import { MedicalRunsheetViewComponent } from './medical-runsheet-view/medical-runsheet-view.component';
import { ERTEmergencyResponseDetailsComponent } from "./ert-emergency-response-details/ert-emergency-response-details.component";
import { ErtEmergencyResponseAdditionalinfoComponent } from "./ert-emergency-response-additionalinfo/ert-emergency-response-additionalinfo.component";

const componentList = [
    ERTEmergencyResponseComponent,
    ErtEmergencyResponseViewComponent,
    ErtEmergencyResponseAdditionalinfoComponent,
    ErtEmergencyResponseAddmrsCreateComponent,
    ErtEmergencyResponseAddmrsAdditionalInfoComponent,
    ErtEmergencyResponseAddmrsPatientVitalsComponent,
    ErtEmergencyResponseAddmrsCreateComponent,
    ERTEmergencyResponseDetailsComponent,
    MedicalRunsheetViewComponent
];

@NgModule({
    imports: [
        MenuModule,
        SharedImportsModule,
        TableControlsComponent,
        MatPaginatorModule,
        CommonModule,
        MatSortModule,
        MatTableModule,
        SharedModule
    ],
    declarations: [componentList],
})
export class ERTEmergencyResponseModule { }
